import SetupClickToCopyButton from "shared/scripts/setup_click_to_copy_button"

// Drives the "How to get started with the IFTTT MCP" showcase: a row of agent
// tabs that swap a single detail panel (Zapier-style), plus copy-to-clipboard
// for the MCP server URL on manual-setup agents.
const McpAgentShowcase = (): void => {
  const root = document.querySelector<HTMLElement>("[data-mcp-agent-showcase]")
  if (!root) return

  const tabs = Array.from(root.querySelectorAll<HTMLButtonElement>("[data-agent-tab]"))
  const panels = Array.from(root.querySelectorAll<HTMLElement>("[data-agent-panel]"))
  if (tabs.length === 0) return

  const selectTab = (tab: HTMLButtonElement, { focus = false } = {}): void => {
    const key = tab.dataset.agentTab

    tabs.forEach(t => {
      const isActive = t === tab
      t.classList.toggle("is-active", isActive)
      t.setAttribute("aria-selected", String(isActive))
      t.tabIndex = isActive ? 0 : -1
    })

    panels.forEach(panel => {
      const isActive = panel.dataset.agentPanel === key
      panel.classList.toggle("is-active", isActive)
      panel.hidden = !isActive
    })

    if (focus) tab.focus()
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => selectTab(tab))

    // Roving-tabindex keyboard navigation between tabs (WAI-ARIA tabs pattern).
    tab.addEventListener("keydown", event => {
      let nextIndex: number | null = null

      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          nextIndex = (index + 1) % tabs.length
          break
        case "ArrowLeft":
        case "ArrowUp":
          nextIndex = (index - 1 + tabs.length) % tabs.length
          break
        case "Home":
          nextIndex = 0
          break
        case "End":
          nextIndex = tabs.length - 1
          break
        default:
          return
      }

      event.preventDefault()
      selectTab(tabs[nextIndex], { focus: true })
    })
  })

  root.querySelectorAll<HTMLElement>("[data-copy-button]").forEach(button => {
    SetupClickToCopyButton({
      buttonElement: button,
      textElement: button.querySelector<HTMLElement>("[data-copy-label]") ?? button,
      contentToCopy: button.dataset.copyValue ?? "",
    })
  })
}

export default McpAgentShowcase
